import { REDUCER_VIRTUAL_CLONE_GET_DATA, REDUCER_VIRTUAL_CLONE_CLEAR } from "../../../../../constants/reducers/widget-page-action-events";
import { REDUCER_SET_META_DATA, REDUCER_CHECKPOINT } from '../../../../../constants/reducers/get-meta-data'
import adjustPages from '../../../../../helpers/merge-page-info'

const DEFAULT_STATE = {}

export default (state = DEFAULT_STATE, action) => {
  const {type} = action

  switch (type) {
    case REDUCER_VIRTUAL_CLONE_GET_DATA:
      return action.payload;
    case REDUCER_VIRTUAL_CLONE_CLEAR:
      return DEFAULT_STATE;
    case REDUCER_CHECKPOINT:
      return 'payload' in action &&
              action.payload &&
              'checkpoint' in action.payload &&
              action.payload.checkpoint &&
              'Envelope' in action.payload.checkpoint &&
              action.payload.checkpoint.Envelope ?
                action.payload.checkpoint.Envelope
              :
                DEFAULT_STATE
    case REDUCER_SET_META_DATA:
      return 'payload' in action &&
              action.payload &&
              'envelope' in action.payload &&
              action.payload.envelope ?
                adjustPages(action.payload.envelope.pages, action.payload.envelope.filters, action.payload.envelope.decorators)
              :
                DEFAULT_STATE
    default:
      return state;
  }
}
